'use client';

import { createContext, useContext, useState } from 'react';

const SupertagContext = createContext(null);

export function SupertagProvider({ children }) {
  const [supertag, setSupertag] = useState([]);

  return <SupertagContext.Provider value={{ supertag, setSupertag }}>{children}</SupertagContext.Provider>;
}

export function useSupertag() {
  const ctx = useContext(SupertagContext);
  if (!ctx) {
    throw new Error('useSupertag must be used within a SupertagProvider');
  }
  return ctx;
}
